import React from 'react'
import { useJsonApi } from 'shared'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Pagination, A11y } from 'swiper'
SwiperCore.use([Navigation, Pagination, A11y])

import placeholder from './placeholder.svg'

type Blog = {
  id: number
  author: any
  image: string
  href: string
  body: string
  published_at: string
  title: string
}
type BlogList = {
  current_page: number
  data: Array<Blog>
  offset: number
  per_page: number
  total_entries: number
  total_pages: number
}
export type BlogPostsApiResult = OperationResponseTypes<'get', '/projects/{projects_id}/blog_posts.json'>
export const AbNewsList = ({ apiUrl, newsUrl }: { apiUrl: string; newsUrl: string }): JSX.Element | null => {
  const { data: blogList } = useJsonApi<BlogList>(apiUrl)
  if (!blogList || blogList?.data.length === 0) return null

  return (
    <div className="bg-white">
      <div className="container mb-12">
        <h2 className="text-center mt-12 mb-4">{I18n.locale === 'de' ? 'Erfolge und Updates' : 'Updates'}</h2>
        {blogList.total_entries === 1 ? (
          <div className="mb-5">
            {blogList.data.map((blog, index) => {
              return <Teaser key={index} blog={blog} horizontal={false} />
            })}
          </div>
        ) : (
          <div className="generic-teaser-swiper select-none mb-5">
            <Swiper
              slidesPerView={1}
              pagination={{
                clickable: blogList.total_entries > 1,
              }}
              roundLengths
              mousewheel={{ forceToAxis: true }}
            >
              {blogList.data.slice(0, 5).map((blog, index) => {
                return (
                  <SwiperSlide key={index}>
                    <Teaser blog={blog} horizontal={false} />
                  </SwiperSlide>
                )
              })}
            </Swiper>
          </div>
        )}
        {blogList.data.length > 1 && (
          <div className="text-center">
            <a href={newsUrl}>
              {I18n.locale === 'de'
                ? `Alle ${blogList.total_entries} Erfolge und Updates anzeigen`
                : `Show all ${blogList.total_entries} updates`}
            </a>
          </div>
        )}
      </div>
    </div>
  )
}

//Based on the the blog teaser on the homepage
//We should use a shared component for both if we want to keep it after the AB test
//Todo: Add proper type after AB test
const Teaser = ({ blog }: any): JSX.Element => {
  const imageUrlPattern = / src="(https:\/\/betterplace-assets.betterplace.org\/uploads[^"?]+\.(jpg|jpeg|gif|png))"/
  const match = blog.body.match(imageUrlPattern)
  const imageUrl = match && match[1]

  return (
    <a href={blog.links[1].href} className="generic-news-post-teaser ab-ppp-news-post-teaser has-small-image h-auto">
      {imageUrl ? (
        <div
          className="news-post-teaser-image"
          style={{
            backgroundImage: 'url(' + imageUrl + ')',
          }}
        ></div>
      ) : (
        <div className="news-post-teaser-image bg-purple-700 flex justify-center items-center">
          <img src={placeholder} alt="" />
        </div>
      )}

      <div className="news-post-teaser-content">
        <h2 className="text-lg">{blog.title}</h2>
        <div className="news-post-teaser-preview" dangerouslySetInnerHTML={{ __html: blog.body }}></div>
        <div className="news-post-teaser-author">
          {blog.author && (
            <>
              <i className="fas fa-user fa-fw" />
              {blog.author?.name}
            </>
          )}
          <i className="fas fa-clock fa-fw" />
          {I18n.l('date.formats.default2', blog.published_at)}
        </div>
      </div>
    </a>
  )
}
